import {Injectable, ErrorHandler} from '@angular/core';
declare let atatus: any;
@Injectable()
export class ExceptionService implements ErrorHandler {
  constructor() {

  }

  handleError(error): void {
     // atatus.notify(error.originalError);
      console.log('error', error);


  }

}



// WEBPACK FOOTER //
// ./src/app/core/exception.service.ts